import { Injectable, Inject, signal } from '@angular/core';
import { EMPTY, catchError, finalize, tap } from 'rxjs';
import { SvcActionPlanHistoryLog } from '../models/svc-action-plan-history.model';
import { ISvcActionPlanHistoryRepository } from '../repositories/svc-action-plan-history.repository.interface';
import { SVC_ACTION_PLAN_HISTORY_REPOSITORY } from '../tokens/svc-action-plan-history.token';

@Injectable({
    providedIn: 'root',
})
export class SvcActionPlanHistoryService {
    private readonly historySignal = signal<SvcActionPlanHistoryLog[]>([]);
    private readonly totalCountSignal = signal<number>(0);
    public loading = signal<boolean>(false);

    public historyLogs = this.historySignal.asReadonly();
    public totalCount = this.totalCountSignal.asReadonly();

    constructor(@Inject(SVC_ACTION_PLAN_HISTORY_REPOSITORY) private repository: ISvcActionPlanHistoryRepository) { }

    public getHistoryLogs(actionPlanId: number): void {
        this.loading.set(true);
        this.repository
            .getHistoryLogs(actionPlanId)
            .pipe(
                tap((response) => {
                    this.historySignal.set(response.items);
                    this.totalCountSignal.set(response.totalCount);
                }),
                catchError((error) => {
                    console.error('Error loading history logs', error);
                    return EMPTY;
                }),
                finalize(() => this.loading.set(false))
            )
            .subscribe();
    }
}
